import axios from "axios";

axios.defaults.baseURL = `${process.env.NODE_ENV === 'development' ? process.env.VUE_APP_TEST_API_URL : process.env.VUE_APP_PRODUCTION_API_URL}`
axios.defaults.headers.common['X-REQUEST-SOURCE'] = 'web';